import { Notification } from "@/utils/notificationUtils";
import { useMutation } from "@tanstack/react-query";
import t from "../../../app/i18n";
import { authApi } from "../../../modules/auth/api";
import { LoginBaseRequest, LoginRequest, VerifyTotpCodeRequest } from "../../../modules/auth/types";

export const AUTH_QUERY_KEYS = {
  session: () => ["session"],
  login: () => ["login"],
  sendTotpCodeViaSms: () => ["sendTotpCodeViaSms"],
  verifyTotpCode: () => ["verifyTotpCode"],
};

export const useLogin = () => {
  return useMutation({
    mutationKey: AUTH_QUERY_KEYS.login(),
    meta: { globalSpinner: false },
    mutationFn: async (payload: LoginRequest) => {
      const { data } = await authApi.login(payload);

      return data;
    },
  });
};

export const useSendTotpCodeViaSms = () => {
  return useMutation({
    mutationKey: AUTH_QUERY_KEYS.sendTotpCodeViaSms(),
    meta: { globalSpinner: false },
    mutationFn: async (payload: LoginBaseRequest) => {
      const { data } = await authApi.sendTotpCodeViaSms(payload);

      return data;
    },
    onSuccess: () => {
      Notification.getNotification().success({
        title: t("common.operationSuccess"),
        description: t("user.helpers.sendTotpCodeViaSmsSuccess"),
      });
    },
  });
};

export const useVerifyTotpCode = () => {
  return useMutation({
    mutationKey: AUTH_QUERY_KEYS.verifyTotpCode(),
    meta: { globalSpinner: false },
    mutationFn: async (payload: VerifyTotpCodeRequest) => {
      const { data } = await authApi.verifyTotpCode(payload);

      return data;
    },
  });
};
